import { BaseError } from '@/util/base-error'

export class AlreadyUsedTelError extends BaseError {
  constructor(message: string) {
    super(message)
  }
}
